module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_1.fbe30a13.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_1.png
// module id = 1169
// module chunks = 16